import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    // Tambahkan snap-start di sini agar footer muncul di urutan scroll
    <footer className="w-full bg-butter-bg border-t border-butter-line pt-16 pb-12 px-5 md:px-10 lg:px-16 snap-start font-butter-sans">
      <div className="max-w-[1280px] mx-auto flex flex-col md:flex-row justify-between items-start md:items-end gap-10">
        
        <div className="flex flex-col gap-2">
          <h2 className="font-butter-serif text-[24px] text-butter-text">buttersando</h2>
          <p className="text-[14px] text-butter-text tracking-wide">a visual archive by ivan sridana</p>
          <p className="text-[12px] text-butter-muted mt-2 italic">based in jakarta, sometimes bali</p>
        </div>

        <div className="flex flex-col items-start md:items-end gap-6">
          <div className="flex flex-wrap gap-6 text-[11px] text-butter-text uppercase tracking-widest">
            <a href="https://instagram.com/buttersando" target="_blank" rel="noopener noreferrer" className="hover:text-butter-accent transition-colors">instagram</a>
            <Link to="/photography/about" className="hover:text-butter-accent transition-colors">about</Link>
            <Link to="/" className="hover:text-butter-accent transition-colors">main site</Link>
            <Link to="/photography/contact" className="hover:text-butter-accent transition-colors">contact</Link>
          </div>
          <p className="text-[11px] text-butter-muted tracking-widest uppercase">
            copyright © 2026 buttersando
          </p>
        </div>
        
      </div>
    </footer>
  );
}